import colors from 'colors'

export const lightOnSurface = colors['light-on-surface']
export const colorFontSmallTitle = colors['gray-40']
export const lightOnSurfaceVariant = colors['light-on-surface-variant']
export const HardlineColor = colors['gray-subtitle']

const useTextStyles = {
  displayLarge: {
    fontSize: '57px',
    lineHeight: '64px',
    fontFamily: 'BB-Font-Bold'
  },
  titleLarge: {
    fontSize: '22px',
    lineHeight: '28px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Bold'
  },
  titleMedium: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontFamily: 'BB-Font-Medium'
  },
  bodyMedium: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Regular'
  },
  bodyLarge: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Bold'
  },
  bodySmall: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: lightOnSurfaceVariant,
    fontFamily: 'BB-Font-Regular'
  },

  titleSmall: {
    fontSize: '14px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: colorFontSmallTitle
  },
  headlineSmall: {
    fontSize: '24px',
    fontFamily: 'BB-Font-Regular',
    lineHeight: '32px',
    alignSelf: 'stretch',
    color: HardlineColor
  },
  headlineLarge: {
    fontFamily: 'BB-Font-Bold',
    fontSize: '32px',
    lineHeight: '40px',
    color: HardlineColor
  },
  labelLarge: {
    fontSize: '14px',
    fontFamily: 'BB-Font-Bold',
    lineHeight: '20px',
    letterSpacing: '0.1px'
  },
  labelMedium: {
    fontSize: '12px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: lightOnSurfaceVariant
  },
  labelSmall: {
    fontSize: '11px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '16px',
    letterSpacing: '0.5px'
  }
}

export default useTextStyles
